// https://icones.js.org/

export enum IconIds {
    CHEVRON_DOWN = 'carbon:chevron-down',
    CHEVRON_UP = 'carbon:chevron-up',
    CHEVRON_RIGHT = 'carbon:chevron-right',
    CHEVRON_LEFT = 'carbon:chevron-left',
    DOUBLE_CHEVRON_LEFT = 'mdi-light:chevron-double-left',
    DOUBLE_CHEVRON_RIGHT = 'mdi-light:chevron-double-right',
    MENU_VERTICAL = 'carbon:overflow-menu-vertical',
    CLOSE = 'carbon:close',
    SEARCH = 'material-symbols:search',
    COPY = 'carbon:copy',
    CHECKMARK = 'carbon:checkmark',
    DOWNLOAD = 'carbon:download',
    UPDATE_NOW = 'carbon:update-now',
    CLOUD_UPLOAD = 'carbon:cloud-upload',
    REPORT = 'carbon:report-data',
    ARROW_LEFT = 'carbon:arrow-left',
    ARROW_RIGHT = 'carbon:arrow-right',
    ARROW_DOWN = 'carbon:arrow-down',
    ARROW_UP = 'carbon:arrow-up',
    ADD_CIRCLED = 'carbon:add-alt',
    ADD = 'carbon:add',
    SUBTRACT_CIRCLED = 'carbon:subtract-alt',
    ACCESS_LOCKED = 'carbon:user-access-locked',
    LINK = 'carbon:link',
    PAUSE = 'carbon:pause-outline',
    MENU = 'material-symbols:menu-rounded',
    OUTLINE_CALENDAR_MONTH = 'ic:outline-calendar-month',
    OUTLINE_MODE_EDIT = 'ic:outline-mode-edit',
    OPEN_LINK_IN_NEW_TAB = 'solar:arrow-right-up-outline',
    THEME_LIGHT = 'line-md:sunny-filled-loop',
    THEME_DARK = 'line-md:sunny-filled-loop-to-moon-filled-alt-loop-transition',
    X = 'ri:twitter-x-fill',
    TELEGRAM = 'ph:telegram-logo',
    TELEGRAM_LOGO = 'ic:baseline-telegram',
    WEBSITE = 'mdi:web-check',
    DISCORD = 'mdi:discord',
    GITHUB = 'mdi:github',
    LINKEDIN = 'mdi:linkedin',
    SIGNAL = 'hugeicons:signal',
    TRANSACTION = 'carbon:text-align-center',
    CONTRACT = 'carbon:cics-program',
    LOADING = 'line-md:loading-twotone-loop',
    WALLET = 'ic:baseline-wallet',
    DOLLAR = 'carbon:currency-dollar',
    STOP_TRADING = 'carbon:pause',
    TERMS = 'material-symbols:contract-edit-outline',
    FAQ = 'carbon:help',
    THUNDER = 'ant-design:thunderbolt-twotone',
    HISTORIC_TIMELINE = 'material-symbols:manage-search',
    TIME = 'carbon:time',
    CELLULAR = 'material-symbols:signal-cellular-alt',
    WIFI = 'material-symbols:wifi',
    SCROLL = 'hugeicons:mouse-scroll-01',
    ASSET_BTC = 'logos:bitcoin',
    ASSET_ETH = 'logos:ethereum',
    ASSET_USD = 'uil:dollar-alt',
    ASSET_EUROS = 'uil:euro',
    LIST = 'ic:twotone-view-headline',
    GROUPED = 'ic:twotone-view-day',
    MINIMALIST = 'ooui:text-summary-rtl',
    CHARTS = 'material-symbols:insert-chart-outline-rounded',
    GAS = 'ri:gas-station-line',
    TRIANGLE_DOWN = 'ic:round-arrow-drop-down',
    TRIANGLE_UP = 'ic:round-arrow-drop-up',
    INFORMATION = 'iconamoon:information-circle',
    SETTINGS = 'ic:baseline-settings',
    DELETE = 'carbon:trash-can',
    EYE = 'carbon:view',
    EYE_OFF = 'carbon:view-off',
    OKTA = 'logos:okta-icon',
    JSON = 'carbon:json',
    UNDO = 'carbon:undo',
    REDO = 'carbon:redo',
    WIFI_OFF = 'carbon:wifi-off',

    // panel
    X_AXIS = 'carbon:x-axis',
    Y_AXIS = 'carbon:y-axis',
    DATA = 'carbon:db2-database',
    TITLE = 'carbon:string-text',
    LEGEND = 'carbon:legend',
    SPACING = 'carbon:linux-namespace',
    EXPORT = 'carbon:export',
    PALETTE = 'carbon:color-palette',
}
